var React  = require('react');
var connect = require('react-redux').connect;
var _      = require('lodash');

var { fetchBenefits } = require('../actions/benefits');

var Loading        = require('patternity/lib/loading');

var WelcomeBenefits = require('../components/benefits');
var WelcomeBenefitsMobile = require('../components/benefits_mobile');

var Benefits = React.createClass({
  propTypes: {
    onSectionChange: React.PropTypes.func.isRequired,
    dispatch: React.PropTypes.func.isRequired,
    isMobile: React.PropTypes.bool.isRequired,
    onCloseDialog: React.PropTypes.func.isRequired,
  },

  componentDidMount: function() {
    this.props.dispatch(fetchBenefits());
    window.pageEventsTracker.startActivity({ category: 'Standard Onboarding', name: 'Welcome Screen' });

  },

  componentWillUnmount: function() {
    window.pageEventsTracker.stopActivity({ category: 'Standard Onboarding', name: 'Welcome Screen' });
  },

  render: function() {
    if(_.isEmpty(this.props.benefits)) {
      return this._renderLoading();
    }

    return this._renderWelcome();
  },

  _renderLoading: function() {
    return (
      <Loading isBlock={true} size="large"/>
    );
  },

  _renderWelcome: function() {
    var data = this.props.benefits;

    if(this.props.isMobile) {
      return (
        <WelcomeBenefitsMobile
          description={data.description}
          clickAction={this._handleSectionChange}
          onCloseDialog={this._handleCloseDialog} />
      );
    }

    return (
      <WelcomeBenefits
          description={data.description}
          clickAction={this._handleSectionChange} />
    );
  },

  _handleSectionChange: function() {
    this.props.onSectionChange('profile');
  },

  _handleCloseDialog: function() {
    window.pageEventsTracker.trackClick({ elementName: 'Skip for now', category: 'Standard Onboarding', pageName: 'Welcome Screen' });
    this.props.onCloseDialog();
  }
});

module.exports = connect(function(state) {
  return state.benefits;
})(Benefits);



// WEBPACK FOOTER //
// ./src/advocate/onboarding/containers/benefits.jsx